import { render, staticRenderFns } from "./modalEnviarSms.vue?vue&type=template&id=152ff039&"
import script from "./modalEnviarSms.vue?vue&type=script&lang=js&"
export * from "./modalEnviarSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports